import { render, staticRenderFns } from "./roleApplyRecord.vue?vue&type=template&id=52536e84&scoped=true"
import script from "./roleApplyRecord.vue?vue&type=script&lang=js"
export * from "./roleApplyRecord.vue?vue&type=script&lang=js"
import style0 from "./roleApplyRecord.vue?vue&type=style&index=0&id=52536e84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52536e84",
  null
  
)

export default component.exports